import createVueComponent from '../createVueComponent';
var Download = createVueComponent('DownloadIcon', [['path', {
  d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4',
  key: '1qkoq5'
}], ['polyline', {
  points: '7 10 12 15 17 10',
  key: '2ggqvy'
}], ['line', {
  x1: '12',
  y1: '15',
  x2: '12',
  y2: '3',
  key: 'nqo27w'
}]]);
export default Download;